import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { MatSort, Sort } from "@angular/material/sort";
import { Store } from '@ngrx/store';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TimeSlots, TimeSlotsFilters } from '../../../commons/models/timeslots';

export type TimeSlotsColumns = ["start_time","end_time", "day_of_week", "active", "actions"];

@Component({
    selector: 'app-time-slots-list',
    templateUrl: './time-slots-list.component.html',
    styleUrls: ['./time-slots-list.component.scss']
})
export class TimeSlotsListComponent{
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    //private store$ : Store;

    @Input()
    timeslots: TimeSlots

    @Input()
    selectedTimeSlot: TimeSlots[];
    
    @Input()
    defaultFilters: TimeSlotsFilters;

    pageSizeOptions = PAGE_SIZE_OPTIONS;
    expandedElement: TimeSlots | null;

    @Input()
    total: Observable<number>;

    @Input()
    displayedColumns: string[] = ["start_time","end_time", "day_of_week", "active", "actions"];

    @Input() canAdd: boolean;
    @Input() canEdit: boolean;
    @Input() canSelect: boolean;

    @Output()
    onLoad: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
    @Output()
    onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
    @Output()
    onFilterChange: EventEmitter<TimeSlotsFilters> = new EventEmitter<TimeSlotsFilters>();

    @Output()
    onSelectTimeSlots : EventEmitter<TimeSlots> = new EventEmitter<TimeSlots>();
    @Output()
    onAddTimeSlots: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onEditTimeSlots: EventEmitter<TimeSlots> = new EventEmitter<TimeSlots>();
    @Output()
    onShowTimeSlots: EventEmitter<TimeSlots> = new EventEmitter<TimeSlots>();
    @Output()
    onAddSelectedTimeSlot: EventEmitter<TimeSlots> = new EventEmitter<TimeSlots>();
    @Output()
    onRemoveSelectedTimeSlot: EventEmitter<TimeSlots> = new EventEmitter<TimeSlots>();
    // @Output() 
    // onDeleteTimeSlot: EventEmitter<TimeSlots> = new EventEmitter<TimeSlots>();
    
    
    get selectedItems(): boolean {
        return this.selectedTimeSlot.length > 0;
    }
    

    ngAfterViewInit() {
      if (this.sort) {
        this.sort.sortChange.subscribe((sort) => {
          this.onSortChange.emit(sort);
        });
      }
  
      if (this.paginator) {
        this.paginator.page.subscribe((pageEvent) => {
          this.onPageChange.emit(pageEvent);
        });
      }
    }

    addTimeSlot() {
      this.onAddTimeSlots.emit();
    }

    editTimeSlot(timeSlots: TimeSlots) {
        this.onEditTimeSlots.emit(timeSlots);
    }

    // deleteTimeSlot(timeSlots: TimeSlots){
    //   this.onDeleteTimeSlot.emit(timeSlots);
    // }
    
    selectTimeSlot(timeSlots: TimeSlots) {
    this.onSelectTimeSlots.emit(timeSlots);
    }

    removeSelectedTimeSlot(timeSlots: TimeSlots) {
    this.onRemoveSelectedTimeSlot.emit(timeSlots)
    }

    onFilter(filters: TimeSlotsFilters) {
        this.paginator.firstPage();
        this.onFilterChange.emit(filters);
    }
  

    showTimeSlot(activityList: TimeSlots) {
        this.onShowTimeSlots.emit(activityList);
    }

    getDayLabel(dayValue: number): string {
      const days = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
      return days[dayValue - 1] || '';
    }
    


}